export { default } from './WixDesignSystemProvider';
export * from './WixDesignSystemProvider.types';
